import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { atxIsMobile$ } from '@epicuro-next/ataraxia/breakpoint';
import { FormatPricePipe } from '@epicuro-next/ataraxia/formatting';
import { IMAGE_MAX_SIZES } from '@epicuro-next/ataraxia/image';
import { MediaObjectFit } from '@epicuro-next/ataraxia/models';
import { IProductDeliveryInfo } from '@epicuro-next/data/lists';
import { stringValueToBoolean } from '@epicuro-next/utilities';
import { Store } from '@ngrx/store';
import { PreviewItem } from 'graphql-api/gql-api-interfaces';
import { ReplaySubject } from 'rxjs';

import { ProductCardBaseComponent } from '../product-card-base/product-card-base.component';

const DATE_FORMAT = 'dd LLLL, YYYY';

@Component({
  selector: 'epc-commercial-product-card',
  templateUrl: './product-card-commercial.component.html',
  styleUrls: ['./product-card-commercial.component.scss'],
  providers: [FormatPricePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProductCardCommercialComponent
  extends ProductCardBaseComponent
  implements OnInit, OnChanges
{
  @Input()
  public imageMaxSizes = IMAGE_MAX_SIZES;

  public objectFit = MediaObjectFit;

  public dateFormat = DATE_FORMAT;

  public deliveryInfoItems$ = new ReplaySubject<PreviewItem[]>();

  public isMobile$ = atxIsMobile$;

  public missedAllPricesTxt = $localize`:ProductList|Commercial list missed all prices tooltip@@missedAllPricesTooltip:Prices are missing for the requested delivery date`;
  public missedSomePricesTxt = $localize`:ProductList|Commercial list missed some prices tooltip@@missedSomePricesTooltip:Prices are missing for the requested delivery date of some sizes`;

  constructor(protected store: Store) {
    super(store);
  }

  public ngOnInit() {
    this.currentVariantMedia = this.product.media;
  }

  public ngOnChanges(changes: SimpleChanges) {
    const { productReference } = changes;

    if (productReference?.currentValue) {
      const deliveryInfoItems: PreviewItem[] =
        productReference.currentValue.deliveryInfo.map(
          ({ productSizeId, quantity }: IProductDeliveryInfo) => ({
            itemId: productSizeId,
            requestedQuantity: quantity,
          }),
        );

      this.deliveryInfoItems$.next(deliveryInfoItems);
    }
  }

  public get isPriceTooltipEnabled(): boolean {
    return this.allPricesMissed || this.isSomePricesMissed;
  }

  public get allPricesMissed(): boolean {
    return this.productReference.totalPrice === 0;
  }

  public get isSomePricesMissed(): boolean {
    return this.productReference.deliveryInfo.some(({ price }) => !price);
  }

  public isAttributeTrue(attribute?: string | boolean | (string | boolean)[]) {
    return stringValueToBoolean(
      Array.isArray(attribute) ? attribute?.[0] : attribute,
    );
  }
}
